export enum AdditionalInfoTestID {
    PreviousButton = 'AdditionalInfoTestID.PreviousButton',
    SubmitButton = 'AdditionalInfoTestID.SubmitButton',
    CountryPicker = 'AdditionalInfoTestID.CountryPicker',
    StatePicker = 'AdditionalInfoTestID.StatePicker',
    CityInput = 'AdditionalInfoTestID.CityInput',
    ZipCodeInput = 'AdditionalInfoTestID.ZipCodeInput',
    LanguagePicker = 'AdditionalInfoTestID.LanguagePicker',
    AvailabilityPicker = 'AdditionalInfoTestID.AvailabilityPicker',
}

export enum TherapyMotivationTestId {
    Continue = 'TherapyMotivationTestId.Continue',
    Previous = 'TherapyMotivationTestId.Previous',
}

export enum TherapySupportWithTestId {
    Continue = 'TherapySupportWithTestId.Continue',
    Previous = 'TherapySupportWithTestId.Previous',
}

export enum WorkWithProviderIntroTestId {
    Continue = 'WorkWithProviderIntroTestId.Continue',
}
